import React from "react";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

export const InfoButton = ({ onClick }) => {
  return (
    <div
      className="h-4 w-4 text-black border-blue-500 border-solid border-2 rounded-[20px] p-[9px]
      flex items-center justify-center hover:bg-blue-500 hover:text-white cursor-pointer"
      onClick={onClick}
    >
      <QuestionMarkIcon sx={{ width: 14, height: 14 }} />
    </div>
  );
};
